function applyTwintStyles(node) {
  const twintIconFilename = "twint_color.svg";
  const newSize = "48px";

  if (node.nodeType === Node.ELEMENT_NODE) {
    let targetElement = null;
    if (node.classList && node.classList.contains('icon-container') && node.style.backgroundImage.includes(twintIconFilename)) {
      targetElement = node;
    } else if (node.querySelector) {
      const potentialIcon = node.querySelector(`.icon-container[style*="${twintIconFilename}"]`);
      if (potentialIcon && potentialIcon.style.backgroundImage.includes(twintIconFilename)) {
        targetElement = potentialIcon;
      } else {
        const childrenIcons = node.querySelectorAll('.icon-container');
        childrenIcons.forEach(childIcon => {
            if (childIcon.style.backgroundImage.includes(twintIconFilename)) {
                targetElement = childIcon;
            }
        });
      }
    }

    if (targetElement && targetElement.style.backgroundSize !== newSize) {
      targetElement.style.backgroundSize = newSize;
    }
  }
}

function observeDOMChanges() {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(newNode => {
          applyTwintStyles(newNode);
          if (newNode.nodeType === Node.ELEMENT_NODE && newNode.querySelectorAll) {
            const nestedIcons = newNode.querySelectorAll('.icon-container');
            nestedIcons.forEach(iconNode => applyTwintStyles(iconNode));
          }
        });
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function updateRyviuWidgetText(widgetTotalElement) {
    const ryviuItem = widgetTotalElement.querySelector('.ryviu-item.product-widget__ryviu');

    if (!ryviuItem) {
        return;
    }

    const starsElement = ryviuItem.querySelector('.r--stars');
    const numberWidget = ryviuItem.querySelector('.ryviu-number-widget');
    let customMessageElement = ryviuItem.querySelector('.custom-no-reviews-message');

    const hasEmptyReviewsData = widgetTotalElement.getAttribute('reviews_data') === '';

    const ryviuItemComputedStyle = window.getComputedStyle(ryviuItem);
    const isRyviuItemVisiblyHidden = ryviuItemComputedStyle.display === 'none' || ryviuItemComputedStyle.visibility === 'hidden';

    const isNumberWidgetInactive = !numberWidget || numberWidget.textContent.trim() === '' || (numberWidget && window.getComputedStyle(numberWidget).display === 'none');
    const shouldShowCustomMessage = hasEmptyReviewsData || (isRyviuItemVisiblyHidden && isNumberWidgetInactive);

    if (shouldShowCustomMessage) {
        if (isRyviuItemVisiblyHidden) {
            ryviuItem.style.display = 'block';
            ryviuItem.style.visibility = 'visible';
            ryviuItem.dataset.forcedOpen = 'true';
        }

        if (starsElement && window.getComputedStyle(starsElement).display === 'none') {
            starsElement.style.display = '';
        }

        if (numberWidget) {
            numberWidget.style.display = 'none';
        }

        if (!customMessageElement && starsElement) {
            customMessageElement = document.createElement('div');
            customMessageElement.className = 'custom-no-reviews-message';
            customMessageElement.textContent = 'Noch keine Bewertung';
            customMessageElement.style.display = 'inline-block';
            customMessageElement.style.verticalAlign = 'middle';
            customMessageElement.style.marginLeft = '8px';

            const ryviuItemStyles = window.getComputedStyle(ryviuItem);
            customMessageElement.style.fontSize = ryviuItemStyles.getPropertyValue('--font--size') || ryviuItemStyles.fontSize || '13px';
            const textColor = (numberWidget && window.getComputedStyle(numberWidget).color !== 'rgba(0, 0, 0, 0)')
                              ? window.getComputedStyle(numberWidget).color
                              : ryviuItemStyles.color;
            customMessageElement.style.color = textColor;

            starsElement.parentNode.insertBefore(customMessageElement, starsElement.nextSibling);
        } else if (customMessageElement && !starsElement) {
            customMessageElement.remove();
        }

    } else {
        if (customMessageElement) {
            customMessageElement.remove();
        }

        if (numberWidget && numberWidget.style.display === 'none') {
            numberWidget.style.display = '';
        }

        if (ryviuItem.dataset.forcedOpen === 'true') {
            ryviuItem.style.display = '';
            ryviuItem.style.visibility = '';
            delete ryviuItem.dataset.forcedOpen;
        }
    }
}

function initializeReviewObservers() {
    const observerCallback = (mutationsList, observerInstance, widgetElement) => {
        updateRyviuWidgetText(widgetElement);
    };

    const setupObserverForWidget = (widgetElement) => {
        if (widgetElement.dataset.observerAttached === 'true') {
            updateRyviuWidgetText(widgetElement);
            return;
        }
        updateRyviuWidgetText(widgetElement);

        const observer = new MutationObserver((mutationsList) => {
            observerCallback(mutationsList, observer, widgetElement);
        });

        observer.observe(widgetElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class', 'reviews_data'],
            characterData: true
        });
        widgetElement.dataset.observerAttached = 'true';
    };

    document.querySelectorAll('ryviu-widget-total').forEach(setupObserverForWidget);

    const bodyObserver = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.matches && node.matches('ryviu-widget-total')) {
                            setupObserverForWidget(node);
                        }
                        else if (node.querySelectorAll) {
                            node.querySelectorAll('ryviu-widget-total').forEach(setupObserverForWidget);
                        }
                    }
                });
            }
        }
    });

    bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}

function initializeAllFeatures() {
    document.querySelectorAll('.icon-container').forEach(existingNode => applyTwintStyles(existingNode));
    observeDOMChanges();
    initializeReviewObservers();
    ['pushState','replaceState'].forEach(method=>{
      const original=history[method];
      history[method]=function(){
        const returnValue=original.apply(this,arguments);
        window.dispatchEvent(new Event('locationchange'));
        return returnValue;
      };
    });
    window.addEventListener('popstate',()=>window.dispatchEvent(new Event('locationchange')));
    window.addEventListener('locationchange', () => {
      initializeReviewObservers();
      // Fallback: nach verzögerter DOM-Aktualisierung nochmal updaten
      [2000].forEach(ms => {
        setTimeout(() => {
          document.querySelectorAll('ryviu-widget-total').forEach(widget => updateRyviuWidgetText(widget));
        }, ms);
      });
    });
    // Führe nach vollständigem Laden der Seite ein Update der Review-Widgets durch
    window.addEventListener('load', () => {
      document.querySelectorAll('ryviu-widget-total').forEach(widget => {
        updateRyviuWidgetText(widget);
      });
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAllFeatures);
} else {
  initializeAllFeatures();
}